import {twMerge} from '@sdox/utils'

import {AwardItem} from './Award.Item'

import type {AwardItemProps} from './Award.Item'
import type {ComponentProps} from 'react'

export interface AwardGridProps extends ComponentProps<'div'> {
  awards?: AwardItemProps[]
}

export const AwardGrid = ({awards = [], className, ...restProps}: AwardGridProps) => (
  <div className={'@container/block'}>
    <div
      className={twMerge(
        'grid grid-cols-2 gap-spacing-8 @[320px]:gap-block-small @block-medium:grid-cols-3 @block-large:grid-cols-4',
        className,
      )}
      {...restProps}
    >
      {awards.map((award, index) => (
        <AwardItem
          key={index}
          {...award}
        />
      ))}
    </div>
  </div>
)
